import { ServiceGroupSaldoResponse } from '@shared/types/osi/saldoByGroups';

export interface IOsiServiceSaldoWidgetViewModel {
  saldoByGroup: ServiceGroupSaldoResponse[];
  isLoading: boolean;
  osiId: number | null;
  // Загрузка начального сальдо из Excel для конкретной группы услуг с последующей перезагрузкой сальдо.
  importSaldo: (groupId: number, file: File) => Promise<void>;
}

export const IOsiServiceSaldoWidgetVmToken = Symbol.for('IOsiServiceSaldoWidgetViewModel');
